import React from 'react';
import { motion } from 'framer-motion';
import './About.css';

const About = () => {
  return (
    <section id="about" className="about section">
      <div className="container">
        <div className="about-content">
          <motion.div 
            className="about-image"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <img src="/P4.png" alt="Real estate and agriculture" />
          </motion.div>
          <motion.div 
            className="about-text"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2>About Wadi empire and builds Ltd</h2>
            <p>Located at KRIZTAL COURT ESTATE, NEAR GOSHEN ESTATE, PYAKASSA, LUGBE, AMAC, FCT, LUGBE, FCT, Wadi empire and builds Ltd is dedicated to real estate purchase and sales, land and estate development, and agricultural development and production. We are committed to building thriving communities and supporting agricultural growth in Nigeria.</p>
            <div className="features">
              {[
                { icon: 'fas fa-home', title: 'Real Estate', desc: 'Expertise in property purchase, sales, and estate development.' },
                { icon: 'fas fa-seedling', title: 'Agricultural Development', desc: 'Promoting sustainable agricultural production and land use.' },
                { icon: 'fas fa-users', title: 'Community Focus', desc: 'Building environments where people and businesses thrive.' }
              ].map((feature, index) => (
                <motion.div 
                  key={index}
                  className="feature"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.2, duration: 0.6 }}
                >
                  <div className="feature-icon">
                    <i className={feature.icon}></i>
                  </div>
                  <div className="feature-content">
                    <h4>{feature.title}</h4>
                    <p>{feature.desc}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
          
          <motion.div 
            className="about-stats"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            {[
              { number: '10+', label: 'Years Experience' },
              { number: '200+', label: 'Healthcare Facilities' },
              { number: '99%', label: 'Uptime Guarantee' }
            ].map((stat, index) => (
              <motion.div 
                key={index}
                className="stat"
                whileHover={{ scale: 1.05 }}
                transition={{ type: "spring", stiffness: 300 }}
              >
                <h3>{stat.number}</h3>
                <p>{stat.label}</p>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;